import { computed } from 'vue';
import { useUISettings } from 'dashboard/composables/useUISettings';

const TAB_SETTING = 'zimobi_conversation_sidebar_tab';

// The contact panel and the cards panel are two tabs of one sidebar, both behind
// `is_contact_sidebar_open`, so upstream's own open/close paths (Alt+O, the copilot switch, the
// contact panel's close button, ConversationView's v-if) keep working without knowing about cards.
export function useConversationSidebarTab() {
  const { uiSettings, updateUISettings } = useUISettings();

  const isCardsTabOpen = computed(
    () =>
      !!uiSettings.value.is_contact_sidebar_open &&
      uiSettings.value[TAB_SETTING] === 'cards'
  );

  const openTab = tab =>
    updateUISettings({
      is_contact_sidebar_open: true,
      is_copilot_panel_open: false,
      [TAB_SETTING]: tab,
    });

  const closeSidebar = () =>
    updateUISettings({ is_contact_sidebar_open: false });

  return { isCardsTabOpen, openTab, closeSidebar };
}
